import { Box, Skeleton, Stack, Typography } from '@mui/material'

export interface StatValue {
  value: string | null
  color?: string
}

interface Props {
  caption: string
  values: StatValue[]
  loading?: boolean
}

export const StatPair = ({ caption, values, loading }: Props) => (
  <Box sx={{ px: 2, py: 1, minWidth: 88, textAlign: 'center' }}>
    <Typography variant='caption' color='text.secondary' display='block'>
      {caption}
    </Typography>

    {loading ? (
      <Skeleton width={56} height={32} sx={{ mx: 'auto' }} />
    ) : (
      <Stack spacing={0}>
        {values.map((stat, index) => (
          <Typography
            key={`${caption}-${index}`}
            variant='h6'
            fontWeight={700}
            sx={{ color: stat.color ?? 'text.primary', lineHeight: 1.3 }}>
            {stat.value ?? '—'}
          </Typography>
        ))}
      </Stack>
    )}
  </Box>
)
